class FaqMain extends HTMLElement {
  constructor() {
    super();
    this.scrollButtons = this.querySelectorAll("[data-scroll-to-category]");
    this.categories = this.querySelectorAll("[data-category-id]");
    this.photoItems = this.querySelectorAll("[data-photo-category]");
    this.observer = null;
    this.lastScrollY = window.scrollY;
    this.activeCategoryIds = new Set();
  }

  eventListeners() {
    this.scrollButtons.forEach(button => {
      button.addEventListener("click", e => this.handleScrollToCategory(e));
    });
  }

  handleScrollToCategory(e) {
    const button = e.currentTarget;
    const categoryId = button.dataset.scrollToCategory;

    if (!categoryId) return;

    const targetCategory = this.querySelector(`[data-category-id="${categoryId}"]`);

    if (!targetCategory) return;

    const categoryHeight = targetCategory.offsetHeight;
    const windowHeight = window.innerHeight;

    // If category is smaller than window, center it. Otherwise, align to start
    const scrollBehavior = categoryHeight < windowHeight ? "center" : "start";

    targetCategory.scrollIntoView({
      behavior: "smooth",
      block: scrollBehavior
    });
  }

  getCategoryIndex(categoryId) {
    return Array.from(this.categories).findIndex(cat => cat.dataset.categoryId === categoryId);
  }

  updateActivePhotos() {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > this.lastScrollY;
    this.lastScrollY = currentScrollY;

    // Get the first photo element
    const firstPhoto = this.photoItems[0];
    const firstPhotoCategoryId = firstPhoto?.dataset.photoCategory;

    // Get array of active category IDs sorted by index
    const sortedActiveIds = Array.from(this.activeCategoryIds).sort((a, b) => {
      return this.getCategoryIndex(a) - this.getCategoryIndex(b);
    });

    if (isScrollingDown) {
      // Scrolling down: Show all photos up to and including the highest active category
      sortedActiveIds.forEach(categoryId => {
        const photo = this.querySelector(`[data-photo-category="${categoryId}"]`);
        if (photo) {
          photo.setAttribute("is-active", "");
        }
      });
    } else {
      // Scrolling up: Only show photos for currently visible categories
      this.photoItems.forEach(photo => {
        const photoCategoryId = photo.dataset.photoCategory;

        // Always keep the first photo active
        if (photoCategoryId === firstPhotoCategoryId) {
          photo.setAttribute("is-active", "");
        } else if (this.activeCategoryIds.has(photoCategoryId)) {
          photo.setAttribute("is-active", "");
        } else {
          photo.removeAttribute("is-active");
        }
      });
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "-40% 0px -50% 0px",
      threshold: 0
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const categoryId = entry.target.dataset.categoryId;

        if (entry.isIntersecting) {
          this.activeCategoryIds.add(categoryId);
        } else {
          this.activeCategoryIds.delete(categoryId);
        }
      });

      this.updateActivePhotos();
    }, options);

    // Observe all categories
    this.categories.forEach(category => {
      this.observer.observe(category);
    });
  }

  init() {
    this.eventListeners();
    this.setupIntersectionObserver();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get("faq-main")) customElements.define("faq-main", FaqMain);
